import React, { useEffect } from 'react'
import recordPCEvent from 'core/utils/RecordEvent/recordPCEvent'
import { tgBotId } from '@/config'

type TTelegramLoginProps = {
  lang: string
  onLoginSuccess?: (data: any) => void
  onLoginError?: () => void
  telegramLogin: string
  size: string
  requestAccess: string
  className?: string
  radius?: string
  redirectUrl?: string
  children?: React.ReactNode
}
export const tgLang = {
  en_US: 'en',
  es_ES: 'es',
  fil_PH: 'en',
  fr_FR: 'fr',
  ja_JP: 'en',
  ko_KR: 'ko',
  pt_PT: 'pt',
  th_TH: 'en',
  vi_VN: 'en',
  zh_CN: 'en',
  zh_HK: 'en',
  de_DE: 'de',
  ru_RU: 'ru',
  tr_TR: 'tr',
  it_IT: 'it',
}
let tgScript: HTMLScriptElement | null = null
export default function TelegramLogin(props: TTelegramLoginProps) {
  useEffect(() => {
    if (tgScript || typeof window === 'undefined') {
      return
    }

    /* 
    <script async src="https://telegram.org/js/telegram-widget.js?22" data-telegram-login="hotcoin_web_test_bot" data-size="large" data-auth-url="https://aa8a-49-228-99-153.ngrok-free.app" data-request-access="write"></script>
    */
    tgScript = document.createElement('script')
    tgScript.async = true
    tgScript.src = 'https://telegram.org/js/telegram-widget.js?22'
    tgScript.setAttribute('data-telegram-login', props.telegramLogin)
    tgScript.setAttribute('data-size', props.size)
    tgScript.setAttribute('data-request-access', props.requestAccess)
    tgScript.setAttribute('data-lang', props.lang)
    if (props.radius) {
      tgScript.setAttribute('data-radius', props.radius)
    }
    if (props.redirectUrl) {
      tgScript.setAttribute('data-auth-url', props.redirectUrl)
    }
    document.head.appendChild(tgScript)
  }, [])
  return (
    <div
      className={props.className}
      onClick={() => {
        recordPCEvent.record('Home_HeroImage_TG')

        window.Telegram.Login.auth(
          {
            bot_id: tgBotId,
            request_access: 'write',
            embed: 1,
            lang: props.lang,
          },
          async (data) => {
            if (data) {
              try {
                // 通过服务端API验证用户数据
                const response = await fetch('/api/telegram-auth', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify(data),
                })

                const result = await response.json()
                if (result.success) {
                  props.onLoginSuccess?.(data)
                } else {
                  props.onLoginError?.()
                }
              } catch (error) {
                console.error('Telegram login error:', error)
                props.onLoginError?.()
              }
            } else {
              props.onLoginError?.()
            }
          }
        )
      }}
    >
      {props.children}
    </div>
  )
}
